<template>
  <div class="introduce">
    <div class="nav">
        <div class="content">
          <i @click="goBack()"></i>
          <span @click="customer()">客服</span>
        </div>
    </div>
    <div class="header">
      <div class="introduce_txt"></div>
    </div>
    <div class="main">
      <div class="block award">
        <div class="title"><span></span>达人推广奖励<span></span></div>
        <!-- <div class="award_list" v-if="version == 0">
          <div class="item">
            <div>
              <span><i>8</i>元</span>
              <span>普通奖励</span>
            </div>
          </div>
          <div class="item">
            <em class="start"></em>
            <em class="tag"></em>
            <div>
              <span><i>9.5</i>元</span>
              <span>达人邀请奖励</span>
            </div>
          </div>
        </div> -->
        <div class="reward_intro" v-if="version == 1">
          <img src="~@/assets/images/reward_intro1.png" />
        </div>
        <div class="reward_intro" v-if="version == 0">
          <img src="~@/assets/images/reward_intro.png" />
        </div>
      </div>
      <div class="block step">
        <div class="title"><span></span>推广步骤<span></span></div>
        <ul class="step_list">
          <li class="step_info">
            <img src="~@/assets/images/step_invite.png"/>
            <p>邀请好友</p>
          </li>
          <li class="step_limit">
            <p><em></em></p>
          </li>
          <li class="step_info">
            <img src="~@/assets/images/step_task.png"/>
            <p>徒弟完成任务</p>
          </li>
          <li class="step_limit">
            <p><em></em></p>
          </li>
          <li class="step_info">
            <img src="~@/assets/images/step_award.png"/>
            <p>获得奖励</p>
          </li>
        </ul>
      </div>
      <div class="block rule">
        <div class="title"><span></span>申请须知<span></span></div>
        <ul v-if="version == 1">
          <li>1.有自己的公众号、千人兼职群、网站等/其他平台邀请记录，超过20人/本平台邀请超过20人，以上条件满足一个即可申请成为达人</li>
          <li>2.每周一核对并发放上周达人数据，奖励直接发放至账户余额；2周均达到达人资格并领取达人奖励的，可享受达人奖励实时到账，无需人工审核发放</li>
          <li>3.达人需在一周内邀请激活（即徒弟完成1次提现）<font color="#EF3D1F" style="font-weight: bold;">100人</font>以上才可保持达人资格，获得达人奖励，否则只能拿到普通邀请奖励</li>
          <li>4.达人可享受提现免门槛，需满足要求后申请</li>
          <li>5.刷量、作弊等方式将直接封禁账号</li>
        </ul>
        <ul v-if="version == 0">
          <li>1.有自己的公众号、千人兼职群、网站等/其他平台邀请记录，超过20人/本平台邀请超过20人，以上条件满足一个即可申请成为达人</li>
          <li>2.每周一核对并发放上周达人数据，奖励直接发放至账户余额</li>
          <li>3.达人需在一周内邀请激活（即徒弟完成1次提现）50人以上才可保持达人资格，获得达人奖励，否则只能拿到普通邀请奖励</li>
          <li>4.刷量、作弊等方式将直接封禁账号</li>
        </ul>
      </div>
    </div>
    <div class="block apply">
      <div class="float_button" @click="apply">申请成为达人</div>
    </div>
    <div class="shadow" :class="{show:isShow}" @click="closeApply">
      <div class="apply_popup" @click.stop="true">
        <div class="apply_content">
          <div class="avatar"><div><img src="~@/assets/images/ccda4a9a1e361d0c896b1c83bd21ee59_format,f_jpg.jpg"/></div></div>
          <div class="userid">{{qq}}</div>
          <div class="qq">
            <div v-clipboard:copy="qq" v-clipboard:success="copy">复制QQ</div>
            <div @click.stop="customer()">打开QQ</div>
          </div>
        </div>
        <div class="cutting">
          <p class="cutting_l"></p><p class="cutting_line">- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -</p><p class="cutting_r"></p>
        </div>
        <div class="ticket">
          <p>申请条件：成功邀请≥20人</p>
          <p>申请方式：加QQ并备注ID</p>
          <p class="tips">注：此QQ仅处理达人申请，其他问题请联系QQ客服</p>
        </div>
      </div>
    </div>
    <loading :isLoad="isLoad"></loading>
  </div>
</template>

<style>
  body {
    background: #F5F7FA;
  }
</style>

<style scoped>
  .nav {
    display: block;
    width: 100%;
    height: 0.22rem;
    color: #F5F7FA;
    position: fixed;
    z-index: 98;
    top: 0.3rem;
  }
  .nav .content {
    display: flex;
    width: 3.43rem;
    padding: 0 .16rem;
    height: 0.22rem;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
  }
  .nav .content i {
    float: left;
    width: 0.17rem;
    height: 0.17rem;
    border-left: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    transform: rotate(45deg);
    overflow: hidden;
  }
  .nav .content span {
    float: right;
    font-size: 16px;
    color: #FFF;
  }
  .header {
    display: flex;
    width: 100%;
    height: 2.37rem;
    background: url('~@/assets/images/introduce_head_bg.png') no-repeat;
    background-size: 3.75rem 2.37rem;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .header .introduce_txt {
    display: block;
    width: 2.25rem;
    height: 0.9rem;
    background: url('~@/assets/images/introduce_txt.png') no-repeat;
    background-size: 2.25rem 0.9rem;
    overflow: hidden;
  }
  .main {
    display: block;
    width: 3.43rem;
    background-color: #F5F7FA;
    margin: 0 auto;
    position: relative;
    top: -0.45rem;
    border-radius: 0.04rem;
    margin-bottom: 0.3rem;
    overflow: hidden;
  }
  .block {
    display: block;
    width: 100%;
    background: #FFF;
    margin-bottom: 0.16rem;
    border-radius: 0.04rem;
    overflow: hidden;
  }
  .block .title {
    display: block;
    width: 100%;
    margin: 0.24rem auto;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    color: #333333;
  }
  .block .title span {
    display: inline-block;
    width: 0.315rem;
    height: 0.09rem;
    margin: 0 0.1rem;
    overflow: hidden;
  }
  .block .title span:first-child {
    background: url('~@/assets/images/title_l.png') no-repeat;
    background-size: 0.315rem 0.09rem;
  }
  .block .title span:last-child {
    background: url('~@/assets/images/title_r.png') no-repeat;
    background-size: 0.315rem 0.09rem;
  }
  .block.award {
    display: block;
    /* height: 1.95rem; */
    overflow: hidden;
  }
  .block.award .reward_intro{
    display: flex;
    width: calc(100% - 0.2rem);
    padding: 0 0.1rem;
    margin-bottom: 0.22rem;
  }
  .block.award .reward_intro img {
    width: 100%;
    height: 100%;
  }

  .block.award .award_list {
    display: flex;
    height: 1.01rem;
    margin: 0 0.16rem 0.31rem 0.16rem;
    justify-content: space-between;
  }
  .block.award .award_list .item {
    display: flex;
    width: 1.5rem;
    height: 1.01rem;
    border: 1px solid #E1E4EB;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.02);
    align-items: center;
  }
  .block.award .award_list .item div {
    width: 100%;
    height: 0.5rem;
    text-align: center;
    overflow: hidden;
  }
  .block.award .award_list .item div span {
    display: block;
  }
  .block.award .award_list .item div span:first-child {
    font-size: 14px;
  }
  .block.award .award_list .item div span:first-child i{
    font-style: normal;
    font-size: 24px;
  }
  .block.award .award_list .item div span:last-child {
    font-size: 14px;
  }
  .block.award .award_list .item:first-child div span:last-child{
    color: #999999;
  }
  .block.award .award_list .item:last-child div span:first-child{
    color: #FF4019;
  }
  .block.award .award_list .item:last-child div span:last-child{
    color: #333333;
  }
  .block.award .award_list .item:last-child {
    position: relative;
  }
  .block.award .award_list .item:last-child em.start {
    display: block;
    width: 0.15rem;
    height: 0.17rem;
    background: url('~@/assets/images/start.png') no-repeat;
    background-size: 0.15rem 0.17rem;
    position: absolute;
    top: -.01rem;
    left: .08rem;
  }
  .block.award .award_list .item:last-child em.tag {
    display: block;
    width: .36rem;
    height: .18rem;
    background: url('~@/assets/images/tag_expire.png') no-repeat;
    background-size: 0.36rem 0.18rem;
    position: absolute;
    top: -.01rem;
    right: 0;
  }
  .block.step {
    display: block;
    height: 1.56rem;
    overflow: hidden;
  }
  .block.step .step_list {
    display: flex;
    list-style: none;
    width: auto;
    height: 0.65rem;
    justify-content: space-around;
    margin: 0 .3rem;
    overflow: hidden;
  }
  .block.step .step_list li.step_info, 
  .block.step .step_list li.step_limit {
    display: block;
    width: auto;
    height: 0.65rem;
    overflow: hidden;
  }
  .block.step .step_list li.step_info img {
    display: block;
    width: 0.38rem;
    height: 0.38rem;
    margin: 0 auto;
  }
  .block.step .step_list li.step_info p {
    font-size: 14px;
    color: #666666;
    margin-top: .05rem;
  }
  .block.step .step_list li.step_limit {
    width: 0.2rem;
  }
  .block.step .step_list li.step_limit p{
    display: flex;
    height: 0.38rem;
    align-items: center;
    justify-content: center;
  }
  .block.step .step_list li.step_limit p em {
    display: block;
    width: .11rem;
    height: .11rem;
    background: url('~@/assets/images/delimiter.png') no-repeat;
    background-size: .11rem .11rem;
  }
  .block.rule {
    display: block;
    /* height: 2.3rem; */
    overflow: hidden;
  }
  .block.rule ul {
    display: block;
    width: auto;
    margin: 0 .26rem;
    line-height: 20px;
    overflow: hidden;
  }
  .block.rule ul li {
    font-size: 14px;
    color: #333333;
    margin-bottom: .15rem;
  }
  .block.apply {
    display: block;
    width: 100%;
    position: fixed;
    background-color: rgba(0, 0, 0, 0);
    bottom: 0;
  }
  .block.apply .float_button {
    display: block;
    width: 3.43rem;
    height: .54rem;
    background: #EF3D1F;
    color: #FFF;
    text-align: center;
    font-size: 20px;
    line-height: .54rem;
    border-radius: 0.3rem;
    margin: 0 auto;
  }
  .apply_popup {
    display: block;
    width: 100%;
    height: 3.68rem;
    margin: 0 auto;
    background: #FFF;
    background-color: rgba(0, 0, 0, 0);
    position: fixed;
    bottom: .15rem;
    overflow: hidden;
  }
  .apply_popup .apply_content {
    display: block;
    width: 3.43rem;
    height: 2.61rem;
    background-color: #FFF;
    margin: 0 auto;
    border-radius: 0.04rem;
    overflow: hidden;
  }
  .apply_popup .apply_content .avatar {
    display: block;
    width: 100%;
    height: .6rem;
    margin-top: .39rem;
    overflow: hidden;
  }
  .apply_popup .apply_content .avatar div{
    width: .6rem;
    height: .6rem;
    border-radius: 100%;
    margin: 0 auto;
    overflow: hidden;
  }
  .apply_popup .apply_content .avatar div img {
    width: 100%;
  }
  .apply_popup .apply_content .userid {
    display: block;
    width: 2.71rem;
    height: .6rem;
    margin: 0 auto;
    margin-top: .12rem;
    background: #FFF7F2;
    border-radius: 4px;
    text-align: center;
    line-height: .6rem;
    font-size: 20px;
    color: #994C2D;
    overflow: hidden;
  }
  .apply_popup .apply_content .qq {
    display: flex;
    width: 2.71rem;
    height: .4rem;
    margin: 0 auto;
    margin-top: .27rem;
    justify-content: space-around;
    overflow: hidden;
  }
  .apply_popup .apply_content .qq div {
    display: block;
    width: 1.1rem;
    height: .4rem;
    line-height: .4rem;
    text-align: center;
    border-radius: 23px;
    font-size: 16px;
    overflow: hidden;
  }
  .apply_popup .apply_content .qq div:first-child {
    background: #FF7F4B;
    color: #FFF;
  }
  .apply_popup .apply_content .qq div:last-child {
    height: .38rem;
    border: 1px solid #FF7F4B;
    color: #FF7F4B;
  }
  .apply_popup .cutting {
    display: block;
    width: 3.43rem;
    height: .2rem;
    background: rgba(0, 0, 0, 0);
    margin: 0 auto;
    overflow: hidden;
  }
  .apply_popup .cutting p{
    display: block;
    float: left;
    height: .2rem;
  }
  .apply_popup .cutting p.cutting_line {
    width: 3.23rem;
    background-color: #FFF;
  }
  .apply_popup .cutting p.cutting_l,
  .apply_popup .cutting p.cutting_r {
    position: relative;
    width: .1rem;
  }
  .apply_popup .cutting p.cutting_l::before {
    content: '';
    width: .2rem;
    height: .2rem;
    border-radius: 100%;
    position: absolute;
    box-shadow: 0 0 0 .1rem #FFF;
    left: -.1rem;
  }
  .apply_popup .cutting p.cutting_r::after {
    content: '';
    width: .2rem;
    height: .2rem;
    border-radius: 100%;
    box-shadow: 0 0 0 .1rem #FFF;
    position: absolute;
    right: -.1rem;
  }
  .apply_popup .ticket {
    display: block;
    width: 3.43rem;
    height: .86rem;
    background: #FFF;
    margin: 0 auto;
    padding-top: 0.1rem;
    overflow: hidden;
  }
  .apply_popup .ticket p {
    text-align: center;
    color: #333333;
    font-size: 16px;
  }
  .apply_popup .ticket p.tips {
    display: block;
    width: 100%;
    text-align: center;
    color: #FF7F4B;
    font-size: 12px;
    margin-top: 0.1rem
  }
  .shadow {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 3.75rem;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    position: fixed;
    z-index: 99;
    top: 0;
  }
  .shadow.show {
    display: flex;
  }
</style>

<script>
import Loading from '@/components/Loading'
import { Toast } from 'vant'

export default {
  created() {
    this.userid = this.getCookie('userid')
    this.deviceid = this.getCookie('device_id')
    if (this.$route.query.debug == 1) {
      this.userid = this.$route.query.userid
      this.deviceid = this.$route.query.deviceid
    }
    // this.userid = '34617925'
    // this.deviceid = '860921041770328'
    this.getVersion() // 显示不同的版本
  },
  components: {
    Loading
  },
  data() {
    return {
      userid: '',
      deviceid: '',
      qq: '3161386275',
      isLoad: false,
      isShow: false,
      version: 0,
    }
  },
  methods: {
    getCookie: function (name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return ""
    },
    getVersion: function () {
      this.isLoad = true
      this.$http.get('/api/user_web/get_introduce_version').then((res) => {
        this.isLoad = false
        let data = res.data
        this.version = data.version
      })
    },
    apply: function () {
      this.isShow = true
    },
    closeApply: function () {
      this.isShow = false
    },
    copy: function () {
      Toast.success('复制成功');
    },
    goBack: function () {
      window.injectedObject.setJsContent('closeWebview', '')
    },
    customer: function () {
      window.injectedObject.setJsContent('qqservice', '3007381093')
    }
  }
}
</script>